import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getCertificationLevelData from './GetCertificationLevelData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  orgLevelId: '',
  officialPositionTypeId: ''
};

const CertificationLevelData = {
  INITIAL_STATE, getCertificationLevelData
}

export default CertificationLevelData;